<template>
  <footer>
    <b-navbar class="footer-navbar">
      <!-- <b-container class="py-5">
        <b-nav vertical class="col-5 footer-col">
          <h5 class="footer-title">{{$t("common.info")}}</h5>
          <router-link class="footer-link" to="/who-are-we">{{
            $t("navigation.aboutUs")
          }}</router-link>
          <router-link class="footer-link" to="/contacts">{{
            $t("navigation.contacts")
          }}</router-link>
          <router-link class="footer-link" to="/about">{{
            $t("navigation.project")
          }}</router-link>
        </b-nav>

        <b-nav vertical class="col-5 footer-col">
          <h5 class="footer-title">Chi Siamo</h5>
          <h5 class="footer-title">Contatti</h5>
          <h5 class="footer-title">Il progetto</h5>
        </b-nav>
      </b-container> -->
      <img src="../assets/atlas.svg" height="30" />
      <h6 class="text-light mb-0 mx-3">Powered by</h6>
      <img src="../assets/dx.png" height="30" />
    </b-navbar>
  </footer>
</template>

<style lang="scss" scoped>
@import "@/variables.scss";

.footer-navbar {
  box-shadow: 0 -0.125rem 0.5rem rgba(0, 0, 0, 0.2);
  margin-top: 3rem;
  background-color: #999;
  color: white;

  .footer-title {
    color: #ffffff;
  }

  .footer-col {
    padding: 0 1rem;
    text-align: center;

    .footer-link {
      color: #ffffffaa;
      cursor: pointer;
      margin: 0.5rem 0;

      &:hover {
        text-decoration: none;
        color: #ffffffdd;
      }
    }
  }
}
</style>

<script>
export default {
  name: "Footer",
};
</script>